import { Link } from "wouter";
import { Helmet } from "react-helmet";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
// Temporarily commenting out StripeConnect until component is fixed
// import { StripeConnect } from "@/components/payments/StripeConnect";
import AgentLayout from "@/components/layout/AgentLayout";

export default function AgentDashboard() {
  const { user } = useAuth();

  return (
    <AgentLayout>
      <Helmet>
        <title>Agent Dashboard | StayMiddle</title>
      </Helmet>
      
      <div className="container py-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold">Agent Dashboard</h1>
            <p className="text-muted-foreground mt-1">
              Manage your properties, bookings, and commissions
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Property Links</CardTitle>
              <CardDescription>Manage your property links</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild className="w-full">
                <Link href="/agent/links">Manage Links</Link>
              </Button>
            </CardContent>
          </Card>
          
          <Card>
            <CardHeader>
              <CardTitle>My Bookings</CardTitle>
              <CardDescription>Bookings from your agent links</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild className="w-full">
                <Link href="/agent/bookings">View Bookings</Link>
              </Button>
            </CardContent>
          </Card>
          
          <Card>
            <CardHeader>
              <CardTitle>My Commissions</CardTitle>
              <CardDescription>Your commission payouts</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild className="w-full">
                <Link href="/agent/commissions">View Commissions</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
        
        <div className="mt-10">
          <Card>
            <CardHeader>
              <CardTitle>Stripe Connect</CardTitle>
              <CardDescription>Connect your Stripe account to receive payments</CardDescription>
            </CardHeader>
            <CardContent>
              {user?.stripeAccountId ? (
                <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <svg 
                        className="h-5 w-5 text-green-400" 
                        viewBox="0 0 20 20" 
                        fill="currentColor"
                      >
                        <path 
                          fillRule="evenodd" 
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" 
                          clipRule="evenodd" 
                        />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <p className="text-sm font-medium text-green-800">
                        Your Stripe account is connected!
                      </p>
                      <p className="text-sm text-green-700 mt-1">
                        You're all set to receive commission payments through Stripe.
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <Button asChild className="w-full bg-gradient-to-r from-purple-600 to-indigo-600">
                  <Link href="/agent/stripe-connect">Connect Stripe Account</Link>
                </Button>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </AgentLayout>
  );
}